import React, {Dispatch, SetStateAction} from "react"
import Typography from "../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"

type Props = {
  setActiveTab: Dispatch<SetStateAction<string>>
  activeTab: string
}

function ActiveSearchTab({setActiveTab, activeTab}: Props) {
	const {t} = useTranslation()

	return (
		<>
			<div className="d-none d-md-flex align-items-start justify-content-start">
				<Typography
					onClick={() => setActiveTab("searchTab")}
					variant="bodyLg"
					semanticTag="div"
					className={`mb-4 active-tab ${activeTab === "searchTab" ? "selected" : ""}`}
				>
					{t("bikes-title", {ns: "search"})}
				</Typography>
				<Typography
					onClick={() => setActiveTab("accessoriesTab")}
					variant="bodyLg"
					semanticTag="div"
					className={`mb-4 active-tab cypress-accessories-tab-results ${activeTab === "accessoriesTab" ? "selected" : ""}`}
				>
					{t("Accessories", {ns: "search"})}
				</Typography>
			</div>

			{/* Mobile tabs */}
			<div className="d-flex d-md-none col-12 align-items-start justify-content-center">
				<Typography
					onClick={() => setActiveTab("searchTab")}
					variant="bodyLg"
					semanticTag="div"
					className={`mb-4 col-6 text-center active-tab ${activeTab === "searchTab" ? "selected" : ""}`}
				>
					{t("bikes-title", {ns: "search"})}
				</Typography>
				<Typography
					onClick={() => setActiveTab("accessoriesTab")}
					variant="bodyLg"
					semanticTag="div"
					className={`mb-4 col-6 text-center active-tab ${activeTab === "accessoriesTab" ? "selected" : ""}`}
				>
					{t("Accessories", {ns: "search"})}
				</Typography>
			</div>
		</>
	)
}

export default React.memo(ActiveSearchTab)
